import { inject, Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

/**
 * Controls the page titles for the application. When a new route is defined the title is set to a localization key which is passed to this service
 * which will append 'Sportlogiq - ' as a prefix. e.g. ('APP_TITLE' becomes 'Sportlogiq - Eventor App')
 */
@Injectable({ providedIn: 'root' })
export class EaTitleStrategy extends TitleStrategy {
    private _title = inject(Title);
    private _translate = inject(TranslateService);

    constructor() {
        super();
    }

    override updateTitle(routerState: RouterStateSnapshot): void {
        const titleKey = this.buildTitle(routerState);

        if (titleKey) {
            this._translate.get(titleKey).subscribe((translatedTitle) => {
                this._title.setTitle(`Sportlogiq - ${translatedTitle}`);
            });

            // handle language changes dynamically while on the page
            this._translate.onLangChange.subscribe(() => {
                this._translate.get(titleKey).subscribe((nextTitle) => {
                    this._title.setTitle(`Sportlogiq - ${nextTitle}`);
                });
            });
        }
    }
}
